import { render, staticRenderFns } from "./sve.vue?vue&type=template&id=48166232&scoped=true"
import script from "./sve.vue?vue&type=script&lang=js"
export * from "./sve.vue?vue&type=script&lang=js"
import style0 from "./sve.vue?vue&type=style&index=0&id=48166232&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48166232",
  null
  
)

export default component.exports